export default "__VITE_ASSET__CQP8AU2m__"